import {Route, Switch} from "react-router-dom";
import {urlService} from "../../routing/urlsService";
import React from "react";
import AdServerTagsDashboardModule from "./adServerTags/adServerTags";
import AdServerTagPage from "./adServerTag/adServerTag";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";


function AdServerTagsModule() {
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }
    return (
        <Switch>
            <Route exact path={urlService.adServerTags()} component={AdServerTagsDashboardModule}/>
            <Route exact path={urlService.adServerTag()} component={AdServerTagPage}/>
        </Switch>
    )
}


export default AdServerTagsModule
